// Alert con varianti di tipo
import { cva, type VariantProps } from 'class-variance-authority'
import { AlertCircle, CheckCircle, Info, XCircle, X } from 'lucide-react'
import { cn } from '../../lib/utils'

const alertVariants = cva(
  'relative flex items-start gap-3 rounded-lg border p-4 text-sm',
  {
    variants: {
      variant: {
        info: 'border-[var(--fc-info)]/30 bg-[color-mix(in_srgb,var(--fc-info)_8%,transparent)] text-[var(--fc-info)]',
        success: 'border-[var(--fc-success)]/30 bg-[color-mix(in_srgb,var(--fc-success)_8%,transparent)] text-[var(--fc-success)]',
        warning: 'border-[var(--fc-warning)]/30 bg-[color-mix(in_srgb,var(--fc-warning)_8%,transparent)] text-[var(--fc-warning)]',
        error: 'border-[var(--fc-danger)]/30 bg-[color-mix(in_srgb,var(--fc-danger)_8%,transparent)] text-[var(--fc-danger)]',
      },
    },
    defaultVariants: {
      variant: 'info',
    },
  }
)

const ALERT_ICONS = {
  info: <Info className="h-5 w-5 shrink-0" />,
  success: <CheckCircle className="h-5 w-5 shrink-0" />,
  warning: <AlertCircle className="h-5 w-5 shrink-0" />,
  error: <XCircle className="h-5 w-5 shrink-0" />,
}

interface AlertProps extends VariantProps<typeof alertVariants> {
  className?: string
  title?: string
  children?: React.ReactNode
  onDismiss?: () => void
}

export function Alert({ className, variant = 'info', title, children, onDismiss }: AlertProps) {
  return (
    <div
      className={cn(alertVariants({ variant }), className)}
      role="alert"
      aria-live="polite"
    >
      {ALERT_ICONS[variant ?? 'info']}
      <div className="flex-1">
        {title && <p className="font-semibold">{title}</p>}
        {children && <p className={cn(title && 'mt-1 opacity-90')}>{children}</p>}
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="shrink-0 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Chiudi"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
